import { render, staticRenderFns } from "./InboundScale.vue?vue&type=template&id=3fa7cfca&scoped=true"
import script from "./InboundScale.vue?vue&type=script&lang=js"
export * from "./InboundScale.vue?vue&type=script&lang=js"
import style0 from "./InboundScale.vue?vue&type=style&index=0&id=3fa7cfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa7cfca",
  null
  
)

export default component.exports